import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import "./HolidaysCalculator.css";
import countries from "./../countries.json";
import checkIsHoliday from "./holiday_api";

const HolidaysCalculator = () => {
    // State variables
    const [hourlyWage, setHourlyWage] = useState(8);  // Hourly wage input
    const [workHours, setWorkHours] = useState(10); // Work hours input
    const [wageTotal, setWageTotal] = useState(0); // Calculated total wage

    const [dateSelected, setDateSelected] = useState(); // Selected date
    const [showAlert, setShowAlert] = useState(false); // Flag to show the alert
    const [holidayResult, setHolidayResult] = useState(null); // Result from the holiday API
    const [holidayResultError, setHolidayResultError] = useState(false);  // Flag for holiday API error
    const countrySelected = useRef("FI");  // Selected country (default to Finland)

    // Event handler for hourly wage input change
    const onChangeHourlyWage = (event) => {
        if (event.target.value <= 0) return;

        setHourlyWage(event.target.value);
    };

    // Event handler for work hours input change
    const onChangeWorkHours = (event) => {
        if (event.target.value <= 0) return;

        setWorkHours(event.target.value);
    };

    // Event handler for date input change
    const onChangeDate = (event) => {
        setDateSelected(event.target.value);
        setShowAlert(false);
    }

    // Event handler for country selection change
    const onChangeCountry = (event) => {
        countrySelected.current = event.target.value
        setShowAlert(false);
    }

    // Event handler for the "Check holiday" button click
    const onClickCalculate = async () => {
        setShowAlert(true);  // Show alert dialog
        if (!dateSelected) return;
        setHolidayResultError(false); // Reset error flag

         // Call the holiday API
        const result = await checkIsHoliday(countrySelected.current, dateSelected)
        if (!result) {
            // Handle API error
            setHolidayResult(null);
            setWageTotal(null);
            setHolidayResultError(true);
            return;
        }
        setHolidayResult(result);
    };

     // Function to determine the alert status (color)
    const getAlertStatus = () => {
        if (holidayResultError) return "alert-danger";
        if (!dateSelected || !wageTotal) return "alert-warning";
        if (!holidayResult) return "alert-info";
        if (!showAlert) return "";

        return holidayResult.isHoliday ? "alert-success" : "alert-primary";
    }

    // Function to generate the wage string for the alert
    const getWageString = () => {
        if (!dateSelected) return "Please select a date.";
        if (holidayResultError) return "Failed to retrieve data from holiday API.";
        if (!holidayResult) return "Loading..";
        if (!showAlert) return "";

        return `Your wage is: ${wageTotal}` + (holidayResult.isHoliday ? ` (Holiday: ${holidayResult.holidayName})`: "");
    }

    useEffect(() => {
        if (hourlyWage <= 0 || workHours <= 0 || !holidayResult) {
            return;
        }
        setWageTotal(hourlyWage * workHours * (holidayResult.isHoliday ? 2 : 1));
    }, [hourlyWage, workHours, holidayResult]);

    return (
        <Container className="HolidaysCalculator  border rounded shadow">
            <Container>
            <Row>
                <Col>
                    <h2>Holiday wage calculator</h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="mt-2">On public holidays, the hourly wage is calculated *2.</p>
                    <hr />
                    <Form>
                        <Form.Label>Hourly wage</Form.Label>
                        <Form.Control onChange={onChangeHourlyWage} value={hourlyWage} type="number"></Form.Control>
                        <Form.Label >Hours worked</Form.Label>
                        <Form.Control onChange={onChangeWorkHours} value={workHours} type="number"></Form.Control>
                        <p>Country:</p>
                        <Form.Select defaultValue={"FI"} onChange={onChangeCountry}>
                            {countries.map((country) =>
                                <option key={country.alpha_3_code} value={country.alpha_2_code}>{country.en_short_name}</option>
                            )}
                        </Form.Select>
                        <label>Date: </label><br/>
                        <input onChange={onChangeDate} className="mb-2 p-2" type="date" id="input_paivamaara" /><br/>
                        <Button className="mb-2" onClick={onClickCalculate}>Check holiday</Button>
                    </Form>
                </Col>
            </Row>
            {/* Conditional rendering of the alert box*/}
            {showAlert && (<Row className="mt-2">
                <Alert className={getAlertStatus()}>
                    {getWageString()}
                </Alert>
            </Row>)}
            </Container>
        </Container>
    );
};
export default HolidaysCalculator;